import { createRouter, createWebHistory } from 'vue-router'
import DashboardView from '../views/DashboardView.vue'
import LoginView from '../views/LoginView.vue'
import SearchforvehicleView from '../views/SearchforvehicleView.vue'
import MylastinspectionsView from '../views/MylastinspectionsView.vue'
import OfflineinspectionView from '../views/OfflineinspectionView.vue'
import StocklistView from '../views/StocklistView.vue'
import CreatestocklistView from '../views/CreatestocklistView.vue'
import HistoryView from '../views/HistoryView.vue'
import LogoutView from '../views/LogoutView.vue'
import SalesphotoshootView from "../views/SalesphotoshootView.vue"
import ManualsalesshootView from '../views/ManualsalesshootView.vue'
import VehicleimagesView from '../views/VehicleimagesView.vue'
import OfflinejobsView from '../views/OfflinejobsView.vue'
import VehicleinView from '../views/VehicleinView.vue'
import VehicleoutView from '../views/VehicleoutView.vue'
import TransporterreturnsView from '../views/TransporterreturnsView.vue'
//import GuestloginsView from '../views/GuestloginsView.vue'


const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: DashboardView,
    meta: {
      requiresAuth: true // Add meta field to indicate protected route
    }
  },
  {
    path: '/login',
    component: LoginView,
    name:'login'
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/manualsalesshoot',
    component: ManualsalesshootView,
    meta: {
      requiresAuth:true
    }
  },
  {
    path: '/offlinejobs',
    component: OfflinejobsView,
    meta: {
      requiresAuth:true
    }
  },
  {
    path: '/logout',
    component: LogoutView
  },
  {
    path: '/searchforvehicle',
    component: SearchforvehicleView,
    meta: {
      requiresAuth:true
    }
  },
  {
    path: '/vehicleimages',
    component: VehicleimagesView,
    meta: {
      requiresAuth:true
    }
  },
  // {
  //   path: '/guestlogins',
  //   component: GuestloginsView,
  //   meta: {
  //     requiresAuth:true
  //   }
  // },
  {
    path: '/offlineinspection/:reg',
    component: OfflineinspectionView,
    meta: {
      requiresAuth:true
    },
    name:'offlineinspection'
  },
  {
    path: '/offlineinspection',
    component: OfflineinspectionView,
    meta: {
      requiresAuth:true
    },
    name:'offlineinspection'
  },
  {
    path: '/mylastinspections',
    component: MylastinspectionsView,
    meta: {
      requiresAuth:true
    }
  },
  {
    path: '/stocklist',
    component: StocklistView,
    meta: {
      requiresAuth:true
    }
  },
  {
    path: '/createstocklist',
    component: CreatestocklistView,
    meta: {
      requiresAuth:true
    }
  },
  {
    path: '/salesshoot',
    component: SalesphotoshootView,
    meta: {
      requiresAuth:true
    }
  },
  {
    path: '/vehiclein',
    component: VehicleinView,
    meta: {
      requiresAuth:true
    }
  },
  {
    path: '/vehicleout',
    component: VehicleoutView,
    meta: {
      requiresAuth:true
    }
  },
  {
    path: '/history/:reg',
    component: HistoryView,
    meta:{
      requiresAuth:true
    },
    name:'history'
  },
  {
    path:'/transporterreturns',
    component: TransporterreturnsView,
    meta: {
      requiresAuth: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

var scrollSection;

router.beforeEach((to, from, next) => {
  scrollSection = document.getElementById("screen");
  if (scrollSection) scrollSection.style.overflow = 'hidden';
  if (to.meta.requiresAuth) {
    const adminid = localStorage.getItem('adminid');
    if (adminid) {
      // User is authenticated, proceed to the route
      next();
    } else {
      // User is not authenticated, redirect to login
      next('/login');
    }
  } else {
    // Non-protected route, allow access
    next();
  }
});

router.afterEach(()=> {
  if (this && this.$nextTick) {
    this.$nextTick(()=> {
        if (scrollSection) scrollSection.style.overflow = 'auto';
    })
  }
})

export default router
